import React from "react";
const Goals = ({ sidebarCollapsed }) => <div className="text-drift-purple text-xl">Goals Page</div>;
export default Goals;
